import { api } from "@/api";
import {
  UpdateSportMappingParams,
  SportProviderMappingDto,
} from "@/types/ApiResponses/Sport";

export const updateSportMapping = async (
  params: UpdateSportMappingParams
): Promise<SportProviderMappingDto> => {
  const { sportId, id, ...body } = params;
  const res = await api.client.patch(
    `/sports-new/${sportId}/mappings/${id}`,
    body
  );
  return res.data;
};
